import { render, staticRenderFns } from "./CoursewareDateInput.vue?vue&type=template&id=1ad5d7f4&"
import script from "./CoursewareDateInput.vue?vue&type=script&lang=js&"
export * from "./CoursewareDateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports